export const EN = {
  label: "en",
  value: "en",
};

export const CY = {
  label: "cy",
  value: "cy",
};
